var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.content ? _c('div', {
    staticClass: "container"
  }, [_vm.state.parsedContent.length ? _c('div', _vm._l(_vm.state.parsedContent, function (item, idx) {
    var _item$text;
    return _c('span', {
      key: idx
    }, _vm._l(item === null || item === void 0 ? void 0 : (_item$text = item.text) === null || _item$text === void 0 ? void 0 : _item$text.split(_vm.emojiRegExp), function (part) {
      return _c('span', {
        key: part
      }, [_vm.EMOJI_CONFIGS_MAP[part] ? _c('img', {
        staticClass: "emoji",
        attrs: {
          "src": _vm.EMOJI_CONFIGS_MAP[part],
          "alt": "emoji"
        }
      }) : _c('span', {
        style: item === null || item === void 0 ? void 0 : item.textStyle,
        domProps: {
          "innerHTML": _vm._s(part)
        },
        on: {
          "click": function click($event) {
            item === null || item === void 0 ? void 0 : item.onClick;
          }
        }
      })]);
    }), 0);
  }), 0) : _vm._e()]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }